import {Stack, Heading, Text} from "@unibuddy/patron";
import React from "react";

export const ConversationPopupThankYou = () => (
    <Stack space="large">
        <Heading size="small" level="2" align="center">
            Thanks!
        </Heading>
        <Text align="center">Your input helps the Assistant improve for future students</Text>
    </Stack>
);
